var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2285,
    cy: 21.5905,
    r: 20.8373,
    stroke: "url(#paint0_linear_4_88843)",
    strokeWidth: 1.50631
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1303 18.9893V21.3215H23.6134V32.23H20.0583V21.3096L16.5797 21.3201V18.9989L20.0675 18.9884L20.0583 18.5262C20.0126 16.2026 20.3331 15.2254 20.3476 15.1786C21.2118 11.7779 24.512 11.9488 24.6535 11.9579L27.6117 11.9588V14.0873H26.4001C24.3458 14.0873 23.6139 15.4754 23.6139 16.7744V18.9893H27.1303Z",
    fill: "url(#paint1_linear_4_88843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_88843",
    x1: 46.6977,
    y1: -43.181,
    x2: -4.04857,
    y2: -42.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_88843",
    x1: 29.3436,
    y1: -11.0457,
    x2: 14.3119,
    y2: -10.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b0a13f2810119f63ca73fee4418f55ba.svg";
export { ForwardRef as ReactComponent };